
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.js'
export type * from './prismaNamespace.js'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  Announcement: 'Announcement',
  AssessmentContent: 'AssessmentContent',
  AssessmentResult: 'AssessmentResult',
  Assessment: 'Assessment',
  AssessmentContentSelectionOverride: 'AssessmentContentSelectionOverride',
  AssistantPrompt: 'AssistantPrompt',
  Org: 'Org',
  School: 'School',
  CoachAvailability: 'CoachAvailability',
  TimeSlot: 'TimeSlot',
  PayCycle: 'PayCycle',
  CoachSessionIncentive: 'CoachSessionIncentive',
  CoachSessionPayment: 'CoachSessionPayment',
  NonSessionPaymentTypeOrder: 'NonSessionPaymentTypeOrder',
  NonSessionPayment: 'NonSessionPayment',
  CoachPayment: 'CoachPayment',
  PurgeRequest: 'PurgeRequest',
  PurgeRequestTableUpdate: 'PurgeRequestTableUpdate',
  SessionFeedback: 'SessionFeedback',
  SessionFeedbackTimeTracking: 'SessionFeedbackTimeTracking',
  StudentFeedback: 'StudentFeedback',
  OnDemandGLA: 'OnDemandGLA',
  JobExecutionState: 'JobExecutionState',
  LearningPath: 'LearningPath',
  LearningPathLesson: 'LearningPathLesson',
  Lesson: 'Lesson',
  EdlinkOrgAssociation: 'EdlinkOrgAssociation',
  EdlinkSchoolAssociation: 'EdlinkSchoolAssociation',
  EdlinkUserAssociation: 'EdlinkUserAssociation',
  V1OrgAssociation: 'V1OrgAssociation',
  V1SchoolAssociation: 'V1SchoolAssociation',
  V1UserAssociation: 'V1UserAssociation',
  Schedule: 'Schedule',
  MeetingBlock: 'MeetingBlock',
  ClassTime: 'ClassTime',
  ScheduleBreak: 'ScheduleBreak',
  SchoolReport: 'SchoolReport',
  SchoolReportSession: 'SchoolReportSession',
  SessionZoom: 'SessionZoom',
  SessionZoomUuid: 'SessionZoomUuid',
  SessionZoomRecordingUrl: 'SessionZoomRecordingUrl',
  SessionGoogleMeet: 'SessionGoogleMeet',
  SubstitutionRequest: 'SubstitutionRequest',
  Session: 'Session',
  StudentSession: 'StudentSession',
  SessionLessonLinkTracking: 'SessionLessonLinkTracking',
  StudentContact: 'StudentContact',
  StudentGroup: 'StudentGroup',
  StudentGroupAudit: 'StudentGroupAudit',
  StudentGroupAttendancePolicyCalculation: 'StudentGroupAttendancePolicyCalculation',
  StudentGroupAttendancePolicyUsageEvent: 'StudentGroupAttendancePolicyUsageEvent',
  StudentGroupReassignmentRequest: 'StudentGroupReassignmentRequest',
  StudentShortLink: 'StudentShortLink',
  UserIdentity: 'UserIdentity',
  UserRole: 'UserRole',
  User: 'User',
  Student: 'Student',
  StudentStatusAudit: 'StudentStatusAudit',
  Coach: 'Coach',
  TotalCountSeasonCoaches: 'TotalCountSeasonCoaches',
  CoachTqReview: 'CoachTqReview',
  AssessmentReviewRequest: 'AssessmentReviewRequest'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const AnnouncementScalarFieldEnum = {
  id: 'id',
  title: 'title',
  content: 'content',
  placement: 'placement',
  type: 'type',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AnnouncementScalarFieldEnum = (typeof AnnouncementScalarFieldEnum)[keyof typeof AnnouncementScalarFieldEnum]


export const AssessmentContentScalarFieldEnum = {
  id: 'id',
  format: 'format',
  name: 'name',
  words: 'words',
  readingPassage: 'readingPassage',
  maxErrorsAllowed: 'maxErrorsAllowed',
  assessmentId: 'assessmentId',
  status: 'status',
  internalOrder: 'internalOrder',
  mappedLowerLevelId: 'mappedLowerLevelId',
  mappedHigherLevelId: 'mappedHigherLevelId',
  requireStudentGrades: 'requireStudentGrades',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssessmentContentScalarFieldEnum = (typeof AssessmentContentScalarFieldEnum)[keyof typeof AssessmentContentScalarFieldEnum]


export const AssessmentResultScalarFieldEnum = {
  id: 'id',
  sessionFeedbackSessionId: 'sessionFeedbackSessionId',
  sessionFeedbackCoachId: 'sessionFeedbackCoachId',
  sessionFeedbackStudentId: 'sessionFeedbackStudentId',
  assessmentContentId: 'assessmentContentId',
  assessmentId: 'assessmentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastUpdatedById: 'lastUpdatedById',
  assessmentFinished: 'assessmentFinished',
  incorrectWords: 'incorrectWords',
  totalWordsRead: 'totalWordsRead',
  incorrectWordsCount: 'incorrectWordsCount',
  phonemicReadingResult: 'phonemicReadingResult',
  comprehensionSkillResult: 'comprehensionSkillResult',
  fluencySkillResult: 'fluencySkillResult',
  comprehensionPassageResult: 'comprehensionPassageResult',
  canRetell: 'canRetell',
  incorrectlWordsReadFromPMList: 'incorrectlWordsReadFromPMList',
  incorrectWordsReadFromDiagnosticPassage: 'incorrectWordsReadFromDiagnosticPassage',
  finishedEarly: 'finishedEarly',
  totalSecondsSpent: 'totalSecondsSpent'
} as const

export type AssessmentResultScalarFieldEnum = (typeof AssessmentResultScalarFieldEnum)[keyof typeof AssessmentResultScalarFieldEnum]


export const AssessmentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  displayName: 'displayName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssessmentScalarFieldEnum = (typeof AssessmentScalarFieldEnum)[keyof typeof AssessmentScalarFieldEnum]


export const AssessmentContentSelectionOverrideScalarFieldEnum = {
  id: 'id',
  lessonId: 'lessonId',
  assessmentId: 'assessmentId',
  assessmentContentId: 'assessmentContentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssessmentContentSelectionOverrideScalarFieldEnum = (typeof AssessmentContentSelectionOverrideScalarFieldEnum)[keyof typeof AssessmentContentSelectionOverrideScalarFieldEnum]


export const AssistantPromptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  content: 'content'
} as const

export type AssistantPromptScalarFieldEnum = (typeof AssistantPromptScalarFieldEnum)[keyof typeof AssistantPromptScalarFieldEnum]


export const OrgScalarFieldEnum = {
  id: 'id',
  name: 'name',
  timeZone: 'timeZone',
  type: 'type',
  status: 'status',
  videoConferenceType: 'videoConferenceType',
  feedbackType: 'feedbackType',
  totalSeats: 'totalSeats',
  preliminaryStartPlainDate: 'preliminaryStartPlainDate',
  preliminaryEndPlainDate: 'preliminaryEndPlainDate',
  teacherBackgroundCheckStatuses: 'teacherBackgroundCheckStatuses',
  teacherTechCheckTypes: 'teacherTechCheckTypes',
  canSendEmailSMS: 'canSendEmailSMS',
  showSessionsToTeachers: 'showSessionsToTeachers',
  isPaymentsEnabled: 'isPaymentsEnabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OrgScalarFieldEnum = (typeof OrgScalarFieldEnum)[keyof typeof OrgScalarFieldEnum]


export const SchoolScalarFieldEnum = {
  id: 'id',
  name: 'name',
  orgId: 'orgId',
  schoolStatus: 'schoolStatus',
  attendancePercentLast14Days: 'attendancePercentLast14Days',
  totalStudents: 'totalStudents',
  studentsInfoUpdatedAt: 'studentsInfoUpdatedAt',
  totalFutureSessions: 'totalFutureSessions',
  nextSessionPlainDate: 'nextSessionPlainDate',
  sessionInfoUpdatedAt: 'sessionInfoUpdatedAt',
  totalSeats: 'totalSeats',
  email: 'email',
  phone: 'phone',
  address: 'address',
  schoolAdminName: 'schoolAdminName',
  needSpanishFeedback: 'needSpanishFeedback',
  canSendSchoolParentReminders: 'canSendSchoolParentReminders',
  canSendFamilyParentReminders: 'canSendFamilyParentReminders',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SchoolScalarFieldEnum = (typeof SchoolScalarFieldEnum)[keyof typeof SchoolScalarFieldEnum]


export const CoachAvailabilityScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  day: 'day',
  startPlainTime: 'startPlainTime',
  endPlainTime: 'endPlainTime',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
} as const

export type CoachAvailabilityScalarFieldEnum = (typeof CoachAvailabilityScalarFieldEnum)[keyof typeof CoachAvailabilityScalarFieldEnum]


export const TimeSlotScalarFieldEnum = {
  day: 'day',
  startPlainTime: 'startPlainTime',
  duration: 'duration',
  popularity: 'popularity',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TimeSlotScalarFieldEnum = (typeof TimeSlotScalarFieldEnum)[keyof typeof TimeSlotScalarFieldEnum]


export const PayCycleScalarFieldEnum = {
  id: 'id',
  startDate: 'startDate',
  endDate: 'endDate',
  paymentDate: 'paymentDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PayCycleScalarFieldEnum = (typeof PayCycleScalarFieldEnum)[keyof typeof PayCycleScalarFieldEnum]


export const CoachSessionIncentiveScalarFieldEnum = {
  id: 'id',
  coachSessionPaymentId: 'coachSessionPaymentId',
  type: 'type',
  bonusAmountInCents: 'bonusAmountInCents',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CoachSessionIncentiveScalarFieldEnum = (typeof CoachSessionIncentiveScalarFieldEnum)[keyof typeof CoachSessionIncentiveScalarFieldEnum]


export const CoachSessionPaymentScalarFieldEnum = {
  id: 'id',
  coachId: 'coachId',
  sessionId: 'sessionId',
  coachPaymentId: 'coachPaymentId',
  paymentAmountInCents: 'paymentAmountInCents',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CoachSessionPaymentScalarFieldEnum = (typeof CoachSessionPaymentScalarFieldEnum)[keyof typeof CoachSessionPaymentScalarFieldEnum]


export const NonSessionPaymentTypeOrderScalarFieldEnum = {
  id: 'id',
  type: 'type',
  order: 'order',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type NonSessionPaymentTypeOrderScalarFieldEnum = (typeof NonSessionPaymentTypeOrderScalarFieldEnum)[keyof typeof NonSessionPaymentTypeOrderScalarFieldEnum]


export const NonSessionPaymentScalarFieldEnum = {
  id: 'id',
  coachPaymentId: 'coachPaymentId',
  type: 'type',
  amountInCents: 'amountInCents',
  createdById: 'createdById',
  deletedById: 'deletedById',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type NonSessionPaymentScalarFieldEnum = (typeof NonSessionPaymentScalarFieldEnum)[keyof typeof NonSessionPaymentScalarFieldEnum]


export const CoachPaymentScalarFieldEnum = {
  id: 'id',
  payCycleId: 'payCycleId',
  coachId: 'coachId',
  type: 'type',
  notes: 'notes',
  nonSessionPaymentId: 'nonSessionPaymentId',
  paymentDateOverride: 'paymentDateOverride',
  paySendId: 'paySendId',
  paymentStatus: 'paymentStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CoachPaymentScalarFieldEnum = (typeof CoachPaymentScalarFieldEnum)[keyof typeof CoachPaymentScalarFieldEnum]


export const PurgeRequestScalarFieldEnum = {
  id: 'id',
  purgeType: 'purgeType',
  orgId: 'orgId',
  schoolId: 'schoolId',
  status: 'status',
  activeTargetId: 'activeTargetId',
  requestedByUserId: 'requestedByUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PurgeRequestScalarFieldEnum = (typeof PurgeRequestScalarFieldEnum)[keyof typeof PurgeRequestScalarFieldEnum]


export const PurgeRequestTableUpdateScalarFieldEnum = {
  id: 'id',
  purgeRequestId: 'purgeRequestId',
  tableName: 'tableName',
  status: 'status',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  errorMessage: 'errorMessage',
  rowsExpected: 'rowsExpected',
  rowsDeleted: 'rowsDeleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PurgeRequestTableUpdateScalarFieldEnum = (typeof PurgeRequestTableUpdateScalarFieldEnum)[keyof typeof PurgeRequestTableUpdateScalarFieldEnum]


export const SessionFeedbackScalarFieldEnum = {
  sessionId: 'sessionId',
  coachId: 'coachId',
  studentId: 'studentId',
  feedbackContent: 'feedbackContent',
  majorConcerns: 'majorConcerns',
  otherTechIssues: 'otherTechIssues',
  issues: 'issues',
  levels: 'levels',
  studentAttended: 'studentAttended',
  feedbackSubmitted: 'feedbackSubmitted',
  lateFeedbackDismissed: 'lateFeedbackDismissed',
  submittedAt: 'submittedAt',
  updatedAt: 'updatedAt',
  draftSavedAt: 'draftSavedAt',
  submittedHoursFromSessionEnd: 'submittedHoursFromSessionEnd',
  dailySummary: 'dailySummary',
  createdAt: 'createdAt'
} as const

export type SessionFeedbackScalarFieldEnum = (typeof SessionFeedbackScalarFieldEnum)[keyof typeof SessionFeedbackScalarFieldEnum]


export const SessionFeedbackTimeTrackingScalarFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  coachId: 'coachId',
  studentId: 'studentId',
  actorId: 'actorId',
  firstStartedAt: 'firstStartedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SessionFeedbackTimeTrackingScalarFieldEnum = (typeof SessionFeedbackTimeTrackingScalarFieldEnum)[keyof typeof SessionFeedbackTimeTrackingScalarFieldEnum]


export const StudentFeedbackScalarFieldEnum = {
  id: 'id',
  studentId: 'studentId',
  studentFeedbackIssue: 'studentFeedbackIssue',
  relevelNeeded: 'relevelNeeded',
  learningPathId: 'learningPathId',
  startingLessonId: 'startingLessonId',
  reviewerId: 'reviewerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  note: 'note',
  status: 'status'
} as const

export type StudentFeedbackScalarFieldEnum = (typeof StudentFeedbackScalarFieldEnum)[keyof typeof StudentFeedbackScalarFieldEnum]


export const OnDemandGLAScalarFieldEnum = {
  id: 'id',
  sourceSessionId: 'sourceSessionId',
  coachId: 'coachId',
  futureSessionId: 'futureSessionId',
  studentId: 'studentId',
  lessonId: 'lessonId',
  recordedStatus: 'recordedStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OnDemandGLAScalarFieldEnum = (typeof OnDemandGLAScalarFieldEnum)[keyof typeof OnDemandGLAScalarFieldEnum]


export const JobExecutionStateScalarFieldEnum = {
  jobName: 'jobName',
  status: 'status',
  cooldownSeconds: 'cooldownSeconds',
  lastFinishedAt: 'lastFinishedAt',
  runningStartedAt: 'runningStartedAt',
  lastError: 'lastError',
  lastTriggeredByUserId: 'lastTriggeredByUserId',
  updatedAt: 'updatedAt'
} as const

export type JobExecutionStateScalarFieldEnum = (typeof JobExecutionStateScalarFieldEnum)[keyof typeof JobExecutionStateScalarFieldEnum]


export const LearningPathScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type LearningPathScalarFieldEnum = (typeof LearningPathScalarFieldEnum)[keyof typeof LearningPathScalarFieldEnum]


export const LearningPathLessonScalarFieldEnum = {
  learningPathId: 'learningPathId',
  lessonId: 'lessonId',
  order: 'order',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type LearningPathLessonScalarFieldEnum = (typeof LearningPathLessonScalarFieldEnum)[keyof typeof LearningPathLessonScalarFieldEnum]


export const LessonScalarFieldEnum = {
  id: 'id',
  name: 'name',
  objectives: 'objectives',
  handouts: 'handouts',
  lessonLinkKTo2: 'lessonLinkKTo2',
  lessonLink3To5: 'lessonLink3To5',
  lessonLink6To8: 'lessonLink6To8',
  shouldSkipFeedback: 'shouldSkipFeedback',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  minWPM: 'minWPM',
  maxWPM: 'maxWPM',
  minAccuracyPercent: 'minAccuracyPercent',
  maxAccuracyPercent: 'maxAccuracyPercent',
  floridaStandard: 'floridaStandard',
  arkansasStandard: 'arkansasStandard'
} as const

export type LessonScalarFieldEnum = (typeof LessonScalarFieldEnum)[keyof typeof LessonScalarFieldEnum]


export const EdlinkOrgAssociationScalarFieldEnum = {
  internalId: 'internalId',
  externalId: 'externalId',
  integrationId: 'integrationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EdlinkOrgAssociationScalarFieldEnum = (typeof EdlinkOrgAssociationScalarFieldEnum)[keyof typeof EdlinkOrgAssociationScalarFieldEnum]


export const EdlinkSchoolAssociationScalarFieldEnum = {
  internalId: 'internalId',
  externalId: 'externalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EdlinkSchoolAssociationScalarFieldEnum = (typeof EdlinkSchoolAssociationScalarFieldEnum)[keyof typeof EdlinkSchoolAssociationScalarFieldEnum]


export const EdlinkUserAssociationScalarFieldEnum = {
  internalId: 'internalId',
  externalId: 'externalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EdlinkUserAssociationScalarFieldEnum = (typeof EdlinkUserAssociationScalarFieldEnum)[keyof typeof EdlinkUserAssociationScalarFieldEnum]


export const V1OrgAssociationScalarFieldEnum = {
  internalId: 'internalId',
  externalId: 'externalId',
  integrationId: 'integrationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type V1OrgAssociationScalarFieldEnum = (typeof V1OrgAssociationScalarFieldEnum)[keyof typeof V1OrgAssociationScalarFieldEnum]


export const V1SchoolAssociationScalarFieldEnum = {
  internalId: 'internalId',
  externalId: 'externalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type V1SchoolAssociationScalarFieldEnum = (typeof V1SchoolAssociationScalarFieldEnum)[keyof typeof V1SchoolAssociationScalarFieldEnum]


export const V1UserAssociationScalarFieldEnum = {
  internalId: 'internalId',
  externalId: 'externalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type V1UserAssociationScalarFieldEnum = (typeof V1UserAssociationScalarFieldEnum)[keyof typeof V1UserAssociationScalarFieldEnum]


export const ScheduleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  startPlainDate: 'startPlainDate',
  endPlainDate: 'endPlainDate',
  timeZone: 'timeZone',
  practicePlainDate: 'practicePlainDate',
  diagnosticPlainDate: 'diagnosticPlainDate',
  status: 'status',
  schoolId: 'schoolId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScheduleScalarFieldEnum = (typeof ScheduleScalarFieldEnum)[keyof typeof ScheduleScalarFieldEnum]


export const MeetingBlockScalarFieldEnum = {
  id: 'id',
  day: 'day',
  startPlainTime: 'startPlainTime',
  endPlainTime: 'endPlainTime',
  classTimeId: 'classTimeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MeetingBlockScalarFieldEnum = (typeof MeetingBlockScalarFieldEnum)[keyof typeof MeetingBlockScalarFieldEnum]


export const ClassTimeScalarFieldEnum = {
  id: 'id',
  type: 'type',
  scheduleId: 'scheduleId',
  status: 'status',
  studentSeats: 'studentSeats',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ClassTimeScalarFieldEnum = (typeof ClassTimeScalarFieldEnum)[keyof typeof ClassTimeScalarFieldEnum]


export const ScheduleBreakScalarFieldEnum = {
  id: 'id',
  startPlainDate: 'startPlainDate',
  endPlainDate: 'endPlainDate',
  name: 'name',
  scheduleId: 'scheduleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScheduleBreakScalarFieldEnum = (typeof ScheduleBreakScalarFieldEnum)[keyof typeof ScheduleBreakScalarFieldEnum]


export const SchoolReportScalarFieldEnum = {
  id: 'id',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  grade: 'grade',
  schoolId: 'schoolId',
  studentId: 'studentId',
  report: 'report',
  reportFromAI: 'reportFromAI',
  reportFromAISpanish: 'reportFromAISpanish',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SchoolReportScalarFieldEnum = (typeof SchoolReportScalarFieldEnum)[keyof typeof SchoolReportScalarFieldEnum]


export const SchoolReportSessionScalarFieldEnum = {
  schoolReportId: 'schoolReportId',
  sessionId: 'sessionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SchoolReportSessionScalarFieldEnum = (typeof SchoolReportSessionScalarFieldEnum)[keyof typeof SchoolReportSessionScalarFieldEnum]


export const SessionZoomScalarFieldEnum = {
  sessionId: 'sessionId',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  coachJoinAt: 'coachJoinAt',
  coachLeaveAt: 'coachLeaveAt',
  attendeeUrl: 'attendeeUrl',
  hostUrl: 'hostUrl',
  zoomUuid: 'zoomUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SessionZoomScalarFieldEnum = (typeof SessionZoomScalarFieldEnum)[keyof typeof SessionZoomScalarFieldEnum]


export const SessionZoomUuidScalarFieldEnum = {
  sessionId: 'sessionId',
  zoomUuid: 'zoomUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SessionZoomUuidScalarFieldEnum = (typeof SessionZoomUuidScalarFieldEnum)[keyof typeof SessionZoomUuidScalarFieldEnum]


export const SessionZoomRecordingUrlScalarFieldEnum = {
  sessionId: 'sessionId',
  recordingUrl: 'recordingUrl',
  recordingId: 'recordingId',
  expirationDate: 'expirationDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SessionZoomRecordingUrlScalarFieldEnum = (typeof SessionZoomRecordingUrlScalarFieldEnum)[keyof typeof SessionZoomRecordingUrlScalarFieldEnum]


export const SessionGoogleMeetScalarFieldEnum = {
  sessionId: 'sessionId',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  coachJoinAt: 'coachJoinAt',
  coachLeaveAt: 'coachLeaveAt',
  attendeeUrl: 'attendeeUrl',
  hostUrl: 'hostUrl',
  checkedAt: 'checkedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SessionGoogleMeetScalarFieldEnum = (typeof SessionGoogleMeetScalarFieldEnum)[keyof typeof SessionGoogleMeetScalarFieldEnum]


export const SubstitutionRequestScalarFieldEnum = {
  id: 'id',
  requestedById: 'requestedById',
  substituteId: 'substituteId',
  sessionId: 'sessionId',
  acceptedAt: 'acceptedAt',
  canceledAt: 'canceledAt',
  hoursUntilSessionStart: 'hoursUntilSessionStart',
  requestReason: 'requestReason',
  status: 'status',
  type: 'type',
  origin: 'origin',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SubstitutionRequestScalarFieldEnum = (typeof SubstitutionRequestScalarFieldEnum)[keyof typeof SubstitutionRequestScalarFieldEnum]


export const SessionScalarFieldEnum = {
  id: 'id',
  studentGroupId: 'studentGroupId',
  start: 'start',
  end: 'end',
  startPlainDate: 'startPlainDate',
  startPlainTime: 'startPlainTime',
  endPlainTime: 'endPlainTime',
  lessonId: 'lessonId',
  coachId: 'coachId',
  substituteCoachId: 'substituteCoachId',
  supportAdminId: 'supportAdminId',
  status: 'status',
  alerts: 'alerts',
  isDelayed: 'isDelayed',
  hourNotification: 'hourNotification',
  canceledAt: 'canceledAt',
  shouldDismissLateTag: 'shouldDismissLateTag',
  shouldDismissEndEarlyTag: 'shouldDismissEndEarlyTag',
  originalTeacherIssue: 'originalTeacherIssue',
  videoConferenceType: 'videoConferenceType',
  hoursCanceledBeforeStart: 'hoursCanceledBeforeStart',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastManualUpdatedAt: 'lastManualUpdatedAt',
  coachSessionRemarksV2: 'coachSessionRemarksV2',
  addedCoachSessionRemarksV2: 'addedCoachSessionRemarksV2',
  removedCoachSessionRemarksV2: 'removedCoachSessionRemarksV2',
  learningLoss: 'learningLoss',
  tnsNotes: 'tnsNotes',
  subNotes: 'subNotes',
  pinnedSubSession: 'pinnedSubSession',
  originalTeacherIssueReason: 'originalTeacherIssueReason',
  originalTeacherIssueReasonDate: 'originalTeacherIssueReasonDate'
} as const

export type SessionScalarFieldEnum = (typeof SessionScalarFieldEnum)[keyof typeof SessionScalarFieldEnum]


export const StudentSessionScalarFieldEnum = {
  sessionId: 'sessionId',
  studentId: 'studentId',
  joinedAt: 'joinedAt',
  leftAt: 'leftAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentSessionScalarFieldEnum = (typeof StudentSessionScalarFieldEnum)[keyof typeof StudentSessionScalarFieldEnum]


export const SessionLessonLinkTrackingScalarFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  userId: 'userId',
  lessonLinkOpenedAt: 'lessonLinkOpenedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SessionLessonLinkTrackingScalarFieldEnum = (typeof SessionLessonLinkTrackingScalarFieldEnum)[keyof typeof SessionLessonLinkTrackingScalarFieldEnum]


export const StudentContactScalarFieldEnum = {
  id: 'id',
  studentId: 'studentId',
  type: 'type',
  name: 'name',
  email: 'email',
  phone: 'phone',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentContactScalarFieldEnum = (typeof StudentContactScalarFieldEnum)[keyof typeof StudentContactScalarFieldEnum]


export const StudentGroupScalarFieldEnum = {
  id: 'id',
  coachId: 'coachId',
  learningPathId: 'learningPathId',
  startingLessonId: 'startingLessonId',
  nextScheduledLessonId: 'nextScheduledLessonId',
  futureScheduledSessionsCount: 'futureScheduledSessionsCount',
  classTimeId: 'classTimeId',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastManualUpdatedAt: 'lastManualUpdatedAt',
  overrideStartPlainDate: 'overrideStartPlainDate',
  overrideEndPlainDate: 'overrideEndPlainDate',
  attendanceStatus: 'attendanceStatus',
  emailsSent: 'emailsSent',
  attendanceNotes: 'attendanceNotes',
  maxPlannedAbsences: 'maxPlannedAbsences',
  shortNoticeSubRequestLimit: 'shortNoticeSubRequestLimit',
  notes: 'notes',
  v1AbsenceText: 'v1AbsenceText'
} as const

export type StudentGroupScalarFieldEnum = (typeof StudentGroupScalarFieldEnum)[keyof typeof StudentGroupScalarFieldEnum]


export const StudentGroupAuditScalarFieldEnum = {
  id: 'id',
  studentGroupId: 'studentGroupId',
  originalCoachId: 'originalCoachId',
  substituteCoachId: 'substituteCoachId',
  coachAssignedAt: 'coachAssignedAt',
  coachUnassignedAt: 'coachUnassignedAt',
  reassigned: 'reassigned',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentGroupAuditScalarFieldEnum = (typeof StudentGroupAuditScalarFieldEnum)[keyof typeof StudentGroupAuditScalarFieldEnum]


export const StudentGroupAttendancePolicyCalculationScalarFieldEnum = {
  id: 'id',
  studentGroupAuditId: 'studentGroupAuditId',
  policyVersion: 'policyVersion',
  eligibleSessionCount: 'eligibleSessionCount',
  totalSubRequestAllowance: 'totalSubRequestAllowance',
  shortNoticeSubRequestAllowance: 'shortNoticeSubRequestAllowance',
  totalSubRequestUsage: 'totalSubRequestUsage',
  shortNoticeSubRequestUsage: 'shortNoticeSubRequestUsage',
  triggeringDimensions: 'triggeringDimensions',
  noShowCount: 'noShowCount',
  lateEntryCount: 'lateEntryCount',
  earlyExitCount: 'earlyExitCount',
  actionLevel: 'actionLevel',
  calculatedAt: 'calculatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentGroupAttendancePolicyCalculationScalarFieldEnum = (typeof StudentGroupAttendancePolicyCalculationScalarFieldEnum)[keyof typeof StudentGroupAttendancePolicyCalculationScalarFieldEnum]


export const StudentGroupAttendancePolicyUsageEventScalarFieldEnum = {
  id: 'id',
  policyCalculationId: 'policyCalculationId',
  sessionId: 'sessionId',
  eventPlainDate: 'eventPlainDate',
  kind: 'kind',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentGroupAttendancePolicyUsageEventScalarFieldEnum = (typeof StudentGroupAttendancePolicyUsageEventScalarFieldEnum)[keyof typeof StudentGroupAttendancePolicyUsageEventScalarFieldEnum]


export const StudentGroupReassignmentRequestScalarFieldEnum = {
  id: 'id',
  studentGroupId: 'studentGroupId',
  effectivePlainDate: 'effectivePlainDate',
  requesterId: 'requesterId',
  reasons: 'reasons',
  preferredCoachId: 'preferredCoachId',
  systemSuggestedCoachId: 'systemSuggestedCoachId',
  specialRequirements: 'specialRequirements',
  reassignmentNotes: 'reassignmentNotes',
  originalCoachId: 'originalCoachId',
  countAsReassignedFromTestTeacher: 'countAsReassignedFromTestTeacher',
  status: 'status',
  teacherReason: 'teacherReason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentGroupReassignmentRequestScalarFieldEnum = (typeof StudentGroupReassignmentRequestScalarFieldEnum)[keyof typeof StudentGroupReassignmentRequestScalarFieldEnum]


export const StudentShortLinkScalarFieldEnum = {
  shortCode: 'shortCode',
  userId: 'userId',
  isActive: 'isActive',
  isPaused: 'isPaused',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentShortLinkScalarFieldEnum = (typeof StudentShortLinkScalarFieldEnum)[keyof typeof StudentShortLinkScalarFieldEnum]


export const UserIdentityScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  iss: 'iss',
  sub: 'sub',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserIdentityScalarFieldEnum = (typeof UserIdentityScalarFieldEnum)[keyof typeof UserIdentityScalarFieldEnum]


export const UserRoleScalarFieldEnum = {
  id: 'id',
  status: 'status',
  role: 'role',
  userId: 'userId',
  schoolId: 'schoolId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserRoleScalarFieldEnum = (typeof UserRoleScalarFieldEnum)[keyof typeof UserRoleScalarFieldEnum]


export const UserScalarFieldEnum = {
  id: 'id',
  first_name: 'first_name',
  last_name: 'last_name',
  email: 'email',
  timeZone: 'timeZone',
  phone: 'phone',
  iss: 'iss',
  sub: 'sub',
  isRegistrable: 'isRegistrable',
  sessionsValidAfterAt: 'sessionsValidAfterAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const StudentScalarFieldEnum = {
  id: 'id',
  grade: 'grade',
  status: 'status',
  fleid: 'fleid',
  specialEd: 'specialEd',
  dyslexic: 'dyslexic',
  ell: 'ell',
  classroomTeacher: 'classroomTeacher',
  learningPathId: 'learningPathId',
  startingLessonId: 'startingLessonId',
  nextSessionLessonId: 'nextSessionLessonId',
  requestedClassTimeId: 'requestedClassTimeId',
  phonicsSkill1Mastered: 'phonicsSkill1Mastered',
  phonicsSkill2Mastered: 'phonicsSkill2Mastered',
  phonicsSkill3Mastered: 'phonicsSkill3Mastered',
  phonicsSkill4Mastered: 'phonicsSkill4Mastered',
  morphemeSkill1Mastered: 'morphemeSkill1Mastered',
  morphemeSkill2Mastered: 'morphemeSkill2Mastered',
  morphemeSkill3Mastered: 'morphemeSkill3Mastered',
  averageAttendanceLast14Days: 'averageAttendanceLast14Days',
  averageAttendanceLast14DaysCalculatedAt: 'averageAttendanceLast14DaysCalculatedAt',
  totalFutureSessions: 'totalFutureSessions',
  nextSessionPlainDate: 'nextSessionPlainDate',
  glaFollowUpStatus: 'glaFollowUpStatus',
  glaReviewerId: 'glaReviewerId',
  glaReviewNotes: 'glaReviewNotes',
  studentTags: 'studentTags',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentScalarFieldEnum = (typeof StudentScalarFieldEnum)[keyof typeof StudentScalarFieldEnum]


export const StudentStatusAuditScalarFieldEnum = {
  id: 'id',
  studentId: 'studentId',
  fromStatus: 'fromStatus',
  toStatus: 'toStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentStatusAuditScalarFieldEnum = (typeof StudentStatusAuditScalarFieldEnum)[keyof typeof StudentStatusAuditScalarFieldEnum]


export const CoachScalarFieldEnum = {
  id: 'id',
  zoomPersonalMeetingUrl: 'zoomPersonalMeetingUrl',
  zoomAccountId: 'zoomAccountId',
  zoomType: 'zoomType',
  zoomInviteStatus: 'zoomInviteStatus',
  zoomPersonalMeetingId: 'zoomPersonalMeetingId',
  isTrial: 'isTrial',
  qualityGrade: 'qualityGrade',
  behaviorNotes: 'behaviorNotes',
  historicalReviewNotes: 'historicalReviewNotes',
  demoGrade: 'demoGrade',
  needsReview: 'needsReview',
  status: 'status',
  subStatuses: 'subStatuses',
  airReadingGoogleMeetUrl: 'airReadingGoogleMeetUrl',
  JPSGoogleMeetUrl: 'JPSGoogleMeetUrl',
  smsReminderOptedIn: 'smsReminderOptedIn',
  displayName: 'displayName',
  secondaryEmail: 'secondaryEmail',
  classEligibilities: 'classEligibilities',
  backgroundCheckStatuses: 'backgroundCheckStatuses',
  zoomTechCheck: 'zoomTechCheck',
  googleMeetTechCheck: 'googleMeetTechCheck',
  attendanceGrade: 'attendanceGrade',
  teachingPreferences: 'teachingPreferences',
  vendorId: 'vendorId',
  paymentInstrumentId: 'paymentInstrumentId',
  paymentAccountConnectedAt: 'paymentAccountConnectedAt',
  paymentAccountUpdatedAt: 'paymentAccountUpdatedAt',
  paymentAccountErrorMessage: 'paymentAccountErrorMessage',
  paymentAccountErrorAt: 'paymentAccountErrorAt',
  last4Ssn: 'last4Ssn',
  paymentAccountType: 'paymentAccountType',
  floridaTutorId: 'floridaTutorId',
  state: 'state',
  referralCode: 'referralCode',
  nextGoogleMeetSessionId: 'nextGoogleMeetSessionId',
  overallGrade: 'overallGrade',
  googleMeetNotes: 'googleMeetNotes',
  googleMeetEvaluationStatus: 'googleMeetEvaluationStatus',
  documentsReviewPassed: 'documentsReviewPassed',
  documentsLastUploadedAt: 'documentsLastUploadedAt',
  workshopPassed: 'workshopPassed',
  onboardingTechCheckPassed: 'onboardingTechCheckPassed',
  qualityGradeUpdatedAt: 'qualityGradeUpdatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CoachScalarFieldEnum = (typeof CoachScalarFieldEnum)[keyof typeof CoachScalarFieldEnum]


export const TotalCountSeasonCoachesScalarFieldEnum = {
  id: 'id',
  startDate: 'startDate',
  endDate: 'endDate',
  season: 'season',
  year: 'year',
  totalCount: 'totalCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TotalCountSeasonCoachesScalarFieldEnum = (typeof TotalCountSeasonCoachesScalarFieldEnum)[keyof typeof TotalCountSeasonCoachesScalarFieldEnum]


export const CoachTqReviewScalarFieldEnum = {
  id: 'id',
  coachId: 'coachId',
  reviewType: 'reviewType',
  status: 'status',
  reviewDate: 'reviewDate',
  reviewGrade: 'reviewGrade',
  notes: 'notes',
  sessionId: 'sessionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CoachTqReviewScalarFieldEnum = (typeof CoachTqReviewScalarFieldEnum)[keyof typeof CoachTqReviewScalarFieldEnum]


export const AssessmentReviewRequestScalarFieldEnum = {
  id: 'id',
  coachId: 'coachId',
  requesterId: 'requesterId',
  status: 'status',
  reason: 'reason',
  satisfiedByReviewId: 'satisfiedByReviewId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssessmentReviewRequestScalarFieldEnum = (typeof AssessmentReviewRequestScalarFieldEnum)[keyof typeof AssessmentReviewRequestScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]

